export default "__VITE_ASSET__BANTUBP7__"